import React, { Component } from 'react'
import styled from 'styled-components'
import { Draggable } from 'react-beautiful-dnd'
import Editor from '../TextEditor/Editor'
import Tooltip from '../../../common/Tooltip'
import ReadOnlyEditor from '../TextEditor/ReadOnlyEditor'
import Modal from '../../../common/Modal'
import UnsavedConfirmationModal from '../../modals/UnsavedConfirmationModal'
import NotesUtil from '../../helpers/NotesUtil'
import tooltips from '../../helpers/tooltips'

const Container = styled.div`
  min-height: 68px;
  margin-bottom: 15px;
  background-color: ${props => (props.draft ? '#F2F2F2' : 'white')};
  border: 0.5px solid #DBDBDC;
  box-shadow: 0 2px 6px 0 #DBDBDC;
  &:hover {
    box-shadow: ${props => (props.isBankUser ? '0 2px 6px 0 #DBDBDC' : '0 2px 19px 0 rgba(51, 153, 204, 0.36)')};
  }
`
const Header = styled.div`
  padding: 12px 15px;
  height: 44px;
  width: 100%;
  color: #56565A;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  line-height: 19px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
`
const QuestionMarkContainer = styled.div`
  display: flex;
  align-items: center;
`
const ContentContainer = styled.div`
  margin-left: 15px;
  min-height: 19px;
  display: flex;
  justify-content: space-between;
`
const DraftContent = styled.div`
  display: inline-flex;
  height: 19px;
  color: #56565A;
  font-family: "Open Sans";
  font-size: 14px;
  font-style: italic;
  line-height: 19px;
  margin-bottom: 15px;
`
const DraftText = styled.div`
  display: inline-flex;
  color: #AE6971;
  padding-right: 5px;
`
const AccessText = styled.div`
display: inline-flex;
color: #808284;
`
const Content = styled.div`
  display: inline-flex;
  color: #808284;
  overflow: hidden;
`
const PublishContent = styled.div`
  min-height: 19px;
  color: #56565A;
  font-family: "Open Sans";
  font-size: 14px;
  line-height: 19px;
  margin-bottom: 15px;
`
const AddExplanation = styled.div`
  padding: 0 0 10px 0;
  margin-left: 15px;
  height: 19px;
  width: 127px;
  color: #48A3D1;
  font-family: "Open Sans";
  font-size: 14px;
  line-height: 19px;
  cursor: pointer;
`
const Line = styled.div`
  box-sizing: border-box;
  height: 1px;
  border: 1px solid ${props => (props.draft ? '#DBDBDC' : '#F4F4F4')};
  margin-right: 15px;
  margin-bottom: 10px;
  margin-left: 15px;
`
const HoverButtonContainer = styled.div`
  display: flex;
  margin-right: 15px;
  margin-bottom: 10px;
  justify-content: flex-end;
`
const Oval = styled.div`
  font-size: 15px;
  display: inline-flex;
  margin-left: 15px;
  height: 24px;
  width: 24px;
  border-radius: 12px;
  background-color: #3399CC;
`
const Icon = styled.i`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: white;
  padding: 5px;
  margin-left: 1px;
  cursor: pointer;
`
const Question = styled.div`
  display: inline-flex;
  border-radius: 100%;
  width: 10px;
  height: 13px;
  background: #f4f4f4;
  color: #888888;
  justify-content: center;
  align-items: center;
  cursor: default !important; 
  margin-left: 3px;
`
const TooltipContainer = styled.div` 
  display: inline;
  position: relative;
  font-size: 13px;
  margin-left: 5px;
`

export default class Topic extends Component {
  constructor(props) {
    super(props)
    const isNewTopic = props.topic.rid === null
    this.state = {
      editorState: isNewTopic ? 'open' : 'closed',
      isHovered: false,
      isEditDraft: !isNewTopic,
      isUnsavedModalOpen: false,
      data: props.topic,
      tooltipHovered: false,
    }
  }

  setIsHovered = isHovered => {
    this.setState({ isHovered })
  }

  setTooltipHovered = tooltipHovered => {
    this.setState({ tooltipHovered })
  }

  setEditorState = value => {
    this.setState({
      editorState: value,
    })
  }

  deleteTopic = () => {
    const { onDeleteTopic } = this.props
    const { rid } = this.state.data

    this.setEditorState('closed')
    onDeleteTopic(rid)
  }

  toggleUnsavedModal = () => {
    this.setState({ isUnsavedModalOpen: !this.state.isUnsavedModalOpen })
  }

  renderUnsavedConfirmation = () => {
    const { isUnsavedModalOpen } = this.state

    return (
      <Modal light isModalOpen={isUnsavedModalOpen}>
        <UnsavedConfirmationModal
          toggleModal={this.toggleUnsavedModal}
          onUnsavedTopic={this.onUnsavedTopic}
          onNoSaveTopic={this.onNoSaveTopic}
        />
      </Modal>
    )
  }

  onNoSaveTopic = () => {
    const { topic: { rid }, onCloseClick } = this.props

    if (rid === null) {
      onCloseClick()
    }
    this.toggleUnsavedModal()
    this.setEditorState('closed')
  }

  onUnsavedTopic = () => {
    const { draft } = this.state.data
    const { editorTitle, editorContent, files} = this.state

    if (draft){
      this.onSaveAsDraftClick(editorTitle, editorContent, files)
    } else {
      this.onPostClick(editorTitle, editorContent, files)
    }
    this.toggleUnsavedModal()
    this.setEditorState('closed')
  }

  onCloseClick = (editorTitle, editorContent) => {
    const { topic: { rid, explanation }, onCloseClick } = this.props

    if (editorContent.length === 0 || editorContent === explanation) {
      if (rid === null) {
        onCloseClick()
      }
      this.setEditorState('closed')
    } else {
      this.toggleUnsavedModal();
      this.renderUnsavedConfirmation();
      this.setState({
        editorTitle,
        editorContent,
      })
    }
  }

  componentWillReceiveProps({ topic }) {
    if (topic !== null) {
      this.setState({
        ...this.state,
        data: topic,
      })
    }
  }

  onNewOrUpdateTopic = props => {
    const { rid } = this.state.data
    const { onSaveNewTopic, onUpdateExistingTopic } = this.props

    if (rid === null) {
      onSaveNewTopic(props)
    } else {
      onUpdateExistingTopic(props)
    }
    this.setEditorState('closed')
  }

  getPropsBasedOnDraft = (draft,editorTitle, editorContent, files, deleteFiles) => {
    const { rid } = this.state.data
    const common = { draft: draft, editorTitle, editorContent, files }

    return rid === null ? {...common} : { rid: rid, deleteFiles, ...common }
  }

  onSaveAsDraftClick = (editorTitle, editorContent, files, deleteFiles) => {
    const props = this.getPropsBasedOnDraft(true, editorTitle, editorContent, files, deleteFiles)

    this.onNewOrUpdateTopic(props)
  }

  onaddAnExplanationClick = () => {
    this.setState({
      editorState: 'open',
      isEditDraft: false,
    })
  }

  onPostClick = (editorTitle, editorContent, files, deleteFiles) => {
    const props = this.getPropsBasedOnDraft(false, editorTitle, editorContent, files, deleteFiles)

    this.onNewOrUpdateTopic(props)
  }

  renderDraftToMarkdown = explanation => {
    const { document } = this.state.data

    return (
      <PublishContent>
        <ReadOnlyEditor
          md={explanation}
          files={document ? document.fileUrls: [] }
        />
      </PublishContent>
    )
  }

  renderHoverButtons = () => {
    const { predefined } = this.state.data

    return (
      <HoverButtonContainer>
        <Oval>
          <Icon
            className="fa fa-pencil"
            onClick={() => this.setEditorState('open')} />
        </Oval>
        {!predefined && (
          <Oval>
            <Icon
              className="fa fa-trash"
              onClick={this.deleteTopic} />
          </Oval>
        )}
      </HoverButtonContainer>
    )
  }

  render() {
    const { rid, topic, draft, predefined, explanation, document } = this.state.data
    const editorState = this.props.editorState || this.state.editorState
    const { isHovered, isEditDraft, tooltipHovered } = this.state
    const { isBankUser } = this.props
    const tooltipText = tooltips.getTooltip(topic)
    const isDragDisabled = (editorState === 'open' || isBankUser)
    const showHoverButtons = editorState === 'closed' && explanation !== null && !isBankUser && isHovered

    return (
      <Draggable draggableId={rid}
            index={this.props.index}
            isDragDisabled={isDragDisabled}
      >
        {(provided, snapshot) => (
          <Container
            {...provided.draggableProps}
            innerRef={provided.innerRef}
            isDragging={snapshot.isDragging}
            draft={draft}
            isBankUser={isBankUser}
            onMouseEnter={() => this.setIsHovered(true)}
            onMouseLeave={() => this.setIsHovered(false)}
          >
            {editorState === 'closed' && (
              <Header
                {...provided.dragHandleProps}
                draft={draft}
              >
                {!predefined && topic}
                {predefined && (
                  <QuestionMarkContainer>
                    {topic}
                    {!isBankUser && (
                      <TooltipContainer>
                        <Question
                          onMouseEnter={() => this.setTooltipHovered(true)}
                          onMouseLeave={() => this.setTooltipHovered(false)}
                          className="fa fa-question-circle"
                        >
                          {tooltipHovered && (
                            <Tooltip
                              bottomEdge={NotesUtil.getTooltipBottomEdge(tooltipText)}
                              left={-30}
                            >
                              {tooltipText}
                            </Tooltip>
                          )}
                        </Question>
                      </TooltipContainer>
                    )}
                  </QuestionMarkContainer>
                )}
                {draft && (
                  <AccessText>
                    {NotesUtil.getAccessText(isBankUser)}
                  </AccessText>
                )}
              </Header>
            )}
            {editorState == 'closed' && (
              <Line draft={draft}/>
            )}
            {explanation === null && editorState === 'closed' && (
              <AddExplanation
                onClick={this.onaddAnExplanationClick}>
                  Add an Explanation
              </AddExplanation>
            )}
            {editorState === 'closed' && explanation !== null && (
              <ContentContainer>
                {draft && (
                  <DraftContent>
                    <DraftText>[Draft]</DraftText>
                    <Content>{explanation}</Content>
                  </DraftContent>
                )}
                {!draft && this.renderDraftToMarkdown((explanation))}
              </ContentContainer>
            )}
            {showHoverButtons && this.renderHoverButtons()}
            {editorState === 'open' && (
              <Editor
                topicName={topic}
                published={!draft}
                predefined={predefined}
                questionStatus={''}
                fileUUIDs={document ? document.files: [] }
                fileUrls={document ? document.fileUrls: [] }
                isBankUser={isBankUser}
                onPostClick={this.onPostClick}
                onSaveAsDraftClick={this.onSaveAsDraftClick}
                onCloseClick={this.onCloseClick}
                onDeleteClick={this.deleteTopic}
                isEditDraft={isEditDraft}
                onFileUpload={this.onFileUpload}
                content={explanation} />
            )}
            {this.renderUnsavedConfirmation()}
          </Container>
        )}
      </Draggable>
    )
  }
}
